import { useMemo } from "react";
import { Link } from "react-router-dom";
import { MapPin, RefreshCw, Coins, Check, Waves, Mountain, Star } from "lucide-react";
import { SpecPill, Pill } from "@/components/common";
import { timeAgo } from "@/lib/labels";
import { FileImage } from "@/components/JobPhotos";

export default function JobCard({ job, index = 0 }) {
  const place = useMemo(() => [job.location, job.country].filter(Boolean).join(", "), [job.location, job.country]);
  return (
    <Link to={`/jobs/${job.id}`} data-testid={`job-card-${job.id}`} style={{ animationDelay: `${index * 50}ms` }}
      className={`rise group panel p-5 sm:p-6 flex flex-col gap-4 hover:border-sky-400 hover:-translate-y-0.5 transition-[transform,border-color,box-shadow] duration-200 hover:shadow-[0_10px_30px_-15px_rgba(2,132,199,.45)] ${job.featured ? "border-amber-400 ring-1 ring-amber-300" : ""}`}>
      {job.photos?.length > 0 && (
        <div className="-mx-5 -mt-5 sm:-mx-6 sm:-mt-6 overflow-hidden rounded-t-[inherit]">
          <FileImage path={job.photos[0]} alt={job.title} testId={`job-card-cover-${job.id}`} className="w-full h-40 object-cover group-hover:scale-[1.03] transition-transform duration-500" />
        </div>
      )}
      <div className="flex items-start justify-between gap-3">
        <div>
          <p className="eyebrow">{job.company_name}</p>
          <h3 className="mt-1 font-bold text-slate-900 text-lg leading-snug group-hover:text-sky-700 transition-colors">{job.title}</h3>
        </div>
        {job.applied && <Pill testId={`job-card-applied-${job.id}`} cls="bg-emerald-50 text-emerald-700 border-emerald-200"><Check size={12} />Applied</Pill>}
        {job.featured && <Pill testId={`job-card-featured-${job.id}`} cls="bg-amber-400 text-slate-950 border-amber-400"><Star size={12} />Featured</Pill>}
      </div>
      <div className="flex flex-wrap gap-1.5">
        <SpecPill spec={job.specialization} />
        <Pill cls={job.site_type === "offshore" ? "bg-slate-900 text-white border-slate-900" : "bg-white text-slate-700 border-slate-300"}>
          {job.site_type === "offshore" ? <Waves size={12} /> : <Mountain size={12} />}{job.site_type}
        </Pill>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 text-sm text-slate-600">
        <span className="flex items-center gap-1.5"><MapPin size={14} className="text-slate-400" />{place}{job.distance_km != null && <span className="font-mono text-xs text-sky-700 whitespace-nowrap" data-testid={`job-distance-${job.id}`}>· {job.distance_km} km</span>}</span>
        {job.rotation && <span className="flex items-center gap-1.5"><RefreshCw size={14} className="text-slate-400" />Rotation {job.rotation}</span>}
        {job.rate && <span className="flex items-center gap-1.5 font-semibold text-slate-800"><Coins size={14} className="text-amber-500" />{job.rate}</span>}
      </div>
      <p className="font-mono text-[11px] text-slate-400 mt-auto">Posted {timeAgo(job.created_at)}</p>
    </Link>
  );
}
